import i18n from '@/lang'

const wordsMap = {
  coins: () => {
    return i18n.t('lang.commonM.k295')
  }
}

export default wordsMap
